import { Component, OnInit } from '@angular/core';
import { AccountOnboarding } from '../../../account/account.model';
import { AccountService } from '../../../account/account.service';
import moment from "moment";
import * as _ from 'lodash';
import { ChartData } from '../../../shared/charts/charts.model';
import { MomentJSHelper } from '../../../shared/utils/moment-js-helper';
import { AccountQueryParams } from 'common';

interface OnboardingSegment {
  name: string;
  value: number;
}

@Component({
    selector: 'ifb-account-onboarding-chart',
    templateUrl: './account-onboarding-chart.component.html',
    styleUrls: ['./account-onboarding-chart.component.scss'],
    standalone: false
})
export class AccountOnboardingChartComponent implements OnInit {

  months: string[];
  currentMonth: string;

  chartData: ChartData = {
    view: [400, 330],
    options: {
      showXAxis: true,
      showYAxis: true,
      gradient: false,
      showLegend: true,
      legendTitle: 'Legend',
      legendPosition: 'below',
      showXAxisLabel: true,
      showYAxisLabel: false,
      colorScheme: {
        domain: ['#747474', '#dbe9f1', '#4a78bc', '#e28f26', '#8e5ea2', '#1c9b41']
      }
    }
  };

  constructor(private _accountService: AccountService) {
    this.currentMonth = moment().format('MMMM');
    this.months = MomentJSHelper.getActiveMonthsCurrentYear();
  }

  ngOnInit() {
    this.fetchData();
  }

  fetchData() {
    const filters = new AccountQueryParams();
    if (this.currentMonth) {
      filters.createdOnFrom = moment().month(this.currentMonth).startOf('month').format('L');
      filters.createdOnTo = moment().month(this.currentMonth).endOf('month').format("L");
    }
    this._accountService.onboardingByAdvisorInfo(filters).subscribe((data: any) => {
      this.chartData.data = _.chain(data)
        .map(value => ({
          name: value.advisor, series: this.mapValues(value.values)
        }))
        .value();
    });
  }

  filterByMonth(value: string): void {
    this.currentMonth = value;
    this.fetchData();
  }

  // Bucket fields only, in stage order. `pushed` is the total of these — stacking it
  // as a segment would render every bar at roughly double its true height.
  private mapValues(values: AccountOnboarding): OnboardingSegment[] {
    return [
      { name: 'Not started', value: values?.none ?? 0 },
      { name: 'Owners registered', value: values?.registered ?? 0 },
      { name: 'Identity verified', value: values?.verified ?? 0 },
      { name: 'Agreement signed', value: values?.signed ?? 0 },
      { name: 'Renewal created', value: values?.renewalCreated ?? 0 },
      { name: 'Activated', value: values?.activated ?? 0 },
    ];
  }

}
